import styled from 'styled-components'
import { Checkbox, FormControlLabel } from '@mui/material'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: 8px;
  justify-content: flex-end;
`

const ChartWithZoomable = ({ seeTotalPeriod, onChange, children }) => {
  const { t } = useTranslation('common')
  return (
    <>
      <Container>
        <FormControlLabel
          control={
            <Checkbox
              checked={seeTotalPeriod}
              onChange={onChange}
            />
          }
          label={t('dashboard.header.zoomable.text')}
        />
      </Container>
      {children}
    </>
  )
}

export default ChartWithZoomable
